import arrowDropRightSvg from '@raison/static/icons/arrow-drop-right-line.svg';
import infoIcon from '@raison/static/icons/info-icon.svg';
import timelineIcon from '@raison/static/icons/time-line.svg';
import React, {ReactNode} from 'react';
import InlineSVG from 'react-inlinesvg';
import {cn} from '../../Utilities';
import {PolyElement, createPolymorphicComponent} from '../../Utilities/createPolymorphicComponent';
import scss from './RsnMessage.module.scss';

export interface RsnMessageProps {
    children?: ReactNode;
    title?: ReactNode;
    arrowed?: boolean;
    centered?: boolean;
    iconSrc?: string;
}

const enum RsnMessageType {
    Notification = 'notification',
    Footnote = 'footnote',
    FootnoteV2 = 'footnoteV2',
    Progress = 'progress',
}

const RsnMessageBase = (
    {children, title, arrowed, centered, ...props}: RsnMessageProps,
    variant: RsnMessageType,
    iconSrc: string
) => (
    <PolyElement className={cn(scss[variant], centered && 'items-center')} {...props}>
        <img src={props.iconSrc ?? iconSrc} className={scss.icon} alt='' />
        {title && <div className={scss.title}>{title}</div>}
        {children && <div className={scss.text}>{children}</div>}
        {arrowed && <img src={arrowDropRightSvg} alt='' className={scss.arrow} />}
    </PolyElement>
);

const Notification = createPolymorphicComponent('button')<RsnMessageProps>(props =>
    RsnMessageBase(props, RsnMessageType.Notification, infoIcon)
);
Notification.displayName = 'RsnMessage.Notification';

const Footnote = createPolymorphicComponent('button')<RsnMessageProps>(props =>
    RsnMessageBase(props, RsnMessageType.Footnote, infoIcon)
);
Footnote.displayName = 'RsnMessage.Footnote';

const FootnoteV2 = ({children, title, arrowed, centered, iconSrc, ...props}: RsnMessageProps) => (
    <div className={cn(scss.footnoteV2, centered && 'items-center')} {...props}>
        <InlineSVG src={iconSrc ?? infoIcon} className={`${scss.iconV2} text-neutral-100`} />
        {title && <div className={scss.title}>{title}</div>}
        {children && <div className={scss.text}>{children}</div>}
        {arrowed && <img src={arrowDropRightSvg} alt='' className={scss.arrow} />}
    </div>
);

const Progress = createPolymorphicComponent('button')<RsnMessageProps>(props =>
    RsnMessageBase(props, RsnMessageType.Progress, timelineIcon)
);
Progress.displayName = 'RsnMessage.Progress';

/**
 * Might have to update this component later to be more versatile.
 */
export const RsnMessage = {
    Notification,
    Progress,
    Footnote,
    FootnoteV2,
};
